<search-bar [ReadCurrentLocation]="true"></search-bar>

<section class="PageBg">
  <div class="container">

    <!--breadcrumb-->
    <div *ngIf="ContextService.IsDesktopView" class="row pt-3 Margin-0">
      <div class="col-md-12 p-0">
        <nav aria-label="breadcrumb" *ngIf="BreadCrumbsDisplayList.length > 0">
          <ol class="breadcrumb">
            <li *ngFor="let item of BreadCrumbsDisplayList; last as isLast" class="breadcrumb-item" title="{{item.Title}}">
              <a [ngClass]="BreadCrumbsDisplayList.length > 1 && isLast ? 'text-black bold-text' : 'text-color'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="item.Url | lowercase">{{item.Title}}</a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <!--breadcrumb-->

    <!--Seo Content-->
    <div class="row Margin-0">
      <div *ngIf="SeoContent" class="alert alert-light" role="alert">
        <div class="col-md-12">
          <div class="row">
            <seo-content-links *ngIf="SeoContent" [IndustryName]="SeoIndustryName" [SeoContent]="SeoContent"></seo-content-links>
          </div>
        </div>
      </div>
    </div>
    <!--Seo Content-->
    <!-- <div class="row" *ngIf="ContextService.IsDesktopView">
      <search-no-result [TotalRecords]="TotalRecords"
        [ShouldShowLocationMessage]="ShouldShowLocationMessage"></search-no-result>
    
      <div class="row m-0 mb-2 mt-2" *ngIf="TotalRecords > 0">
        <div class="col-md-6 col-sm-6 mb-sm-2 p-0 MobileFix pr-sm-2"> -->
          <!-- <button class="btn btn-primary btn-md" (click)="SetJobAlert()" role="button" title="Email matching jobs and create auto search"> -->
          <!-- <i class="fa fa-envelope-open-text"></i> Email Matching Jobs -->
          <!-- </button> -->
        <!-- </div>
      </div>
    </div> -->
    <div class="col MobileFix sort-search text-right" *ngIf="ContextService.IsDesktopView">
      <sort-search-item></sort-search-item>
    </div>
    <!--3 Cols-->
    <div class="row pb-3 Margin-0">
      <div class="col-lg-3 col-sm-12 p-0">
        <search-filter [SectorName]="SearchParams.SectorName" [SelectedJobTypes]="SelectedJobTypes"></search-filter>
      </div>

      <div class="col-lg-9 col-sm-12 p-0 mt-5">
        <div *ngIf="!ContextService.IsDesktopView">
          <!-- <search-no-result [TotalRecords]="TotalRecords" [ShouldShowLocationMessage]="ShouldShowLocationMessage"></search-no-result> -->

        <div class="row m-0 mb-2 mt-2" *ngIf="TotalRecords > 0">
          <div class="col-md-6 col-sm-6 mb-sm-2 p-0 MobileFix pr-sm-2">
            <!-- <button class="btn btn-primary btn-md" (click)="SetJobAlert()" role="button" title="Email matching jobs and create auto search"> -->
              <!-- <i class="fa fa-envelope-open-text"></i> Email Matching Jobs -->
            <!-- </button> -->
          </div>
          <div class="col-md-6 col-sm-6 text-right p-0 MobileFix">
            <sort-search-item></sort-search-item>
          </div>
        </div>
        </div>
        
        <div class="SearchResults">
          <search-no-result [TotalRecords]="TotalRecords"
        [ShouldShowLocationMessage]="ShouldShowLocationMessage"></search-no-result>
        <job-card-loader *ngIf="isLoading"></job-card-loader>
          <smart-job-card [Jobs]="Jobs" [WordsToHighlight]="ResultsFoundFor" [IsHideIconRequired]="true" (OnHideJob)="OnHideJob($event)"
          [IsSearchResultPage]="true" [CurrentPageNumber]="SearchParams.PageNumber" [IsExternalRecords]="IsExternalRecords"
          [CurrentVisitedPage]="'Job-Search'"></smart-job-card>
        </div>
        <smart-pagination *ngIf="TotalRecords && ContextService.IsBrowser" [TotalRecords]="TotalRecords"
          [PageNumber]="SearchParams.PageNumber" (PageNumberChanged)="OnPageNumberChanged($event)"
          (PageSizeChanged)="OnPageSizeChanged($event)" [PageSize]="SearchParams.PageSize">
        </smart-pagination>
      </div>
    </div>
    <!--3 Cols-->

  </div>
</section>

<button id="AutoSaveSearchConfirmationModal" class="d-none" data-toggle="modal" data-target="#UserSaveSearchConfirmModel"></button>
<smart-modal [Id]="'UserSaveSearchConfirmModel'" [Title]="'Please Confirm'" [ShowFooter]="false">
  <div modal-body>
    <div class="row m-0">
      <span class="text-center">Would you like to see your save search.?</span>
    </div>
    <div class="row m-0 pull-right">
      <div class=" col-md-12 p-0">
        <button modal-footer type="button" class="btn btn-success btn-sm" (click)="OnConfirmSaveSearchModal()">Yes</button>
        <button modal-footer type="button" class="btn btn-primary btn-sm" id="CloseSaveSearchConfirmModal" (click)="OnCloseSaveSearchModal()" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</smart-modal>